import { render } from "./p-modal-date-range.vue?vue&type=template&id=073edc97"
import script from "./p-modal-date-range.vue?vue&type=script&lang=js"
export * from "./p-modal-date-range.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__